








































































































































































































import TabsOffice from "@/components/tabs/office.vue";
import Vue from "vue";
import Component from "vue-class-component";
import Page from "@/components/layout/page.vue";
import { Office } from "@/swagger/models";
import { Committable, WrapService } from "@/plugins/committable";
import CommitResetBar from "@/components/data/commit-reset-bar.vue";
import Card from "@/components/layout/card.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import { subject } from "@casl/ability";
import { officeService } from "@/services/office";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "office",
    components: { TabsOffice, PageHeader, Card, CommitResetBar, Page },
})
export default class OfficeView extends Vue {
    committable: Committable<Office>;

    // nextId: number = null;
    // previousId: number = null;

    async created() {
        try {
            this.committable = new Committable<Office>({
                onCommit: WrapService(officeService, {
                    ignoredFields: ["deletedAt"],
                    routeIdParam: "officeId",
                    router: this.$router,
                }),
            });

            if (this.$route.params.officeId === "new") {
                this.committable.set(
                    officeService.build({
                        customerId: parseInt(this.$route.params.customerId),
                    }),
                );
            } else {
                const res = await officeService.getNew(parseInt(this.$route.params.officeId));
                this.committable.set(res.data);
                // this.previousId = res.previousId;
                // this.nextId = res.nextId;
            }
        } catch (e) {
            console.warn(e);
            await this.$router.back();
        }
    }

    get canEdit() {
        if (this.committable.loading.value) return false;
        // @ts-ignore
        if (this.$route.params.officeId === "new" && this.$can("create", "Office")) return true;
        // @ts-ignore
        else if (this.$can("update", subject("Office", this.committable?.original?.value))) return true;
        return false;
    }
}
